import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Grid,
  Modal,
  Typography,
  styled,
  TextField,
  CircularProgress,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import BlankImg from "../../assets/images/blank.jpg";
import GoalVideo from "./GoalVideo";
import { useSelector } from "react-redux";
import ImageUploadComponent from "./admin/editGoalModalComponents/ImgUpload/Index";
import { GOAL_STATUS_OPTIONS } from "../../utils/goalStatus";

const EditGoal = ({ open, setOpen, selectedGoal, handleGoalUpdate }) => {
  const goalCategory = useSelector((state) => state.goalCategories?.data?.data);
  const [loading, setLoading] = useState(false);

  const categoryOptions =
    goalCategory?.map((item) => {
      return {
        value: item.id,
        label: item.name,
      };
    }) || [];

  const goalSubCategoryOption = goalCategory
    ?.map((item) =>
      item.id == 6
        ? item?.subCategory?.map((subCat) =>
            subCat?.childSubCategories ? [...subCat?.childSubCategories] : [],
          )
        : [],
    )
    .flat(2);

  // "";

  const CustomTextarea = styled(TextField)(() => {
    return {
      width: "100%",
      "& .MuiOutlinedInput-root": {
        backgroundColor: "transparent",
        borderRadius: "8px",
        color: "black",
        padding: "0",
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "#e5e7eb",
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#1976d2",
          borderWidth: 2,
        },
      },
      "& .MuiInputBase-input": {
        padding: "10px 12px",
      },
    };
  });

  const initialValues = React.useMemo(
    () => ({
      title: selectedGoal?.title || "",
      region: selectedGoal?.region || "",
      postedBy: selectedGoal?.goalUserDetails?.firstName || "",
      category: selectedGoal?.category || "",
      from_uk: selectedGoal?.from_uk || false,
      club: selectedGoal?.club || "",
      sub_category: selectedGoal?.goalSubCategory?.id,
      club_img: selectedGoal?.club_img,
      goal_scorer: selectedGoal?.goal_scorer || "",
      rikognition_status:
        selectedGoal?.rikognition_status || "verification_pending",
    }),
    [selectedGoal],
  );

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      title: Yup.string().required("Please fill the title"),
      region: Yup.string().required("Please fill the region"),
      postedBy: Yup.string().required("Please fill the posted by"),
      category: Yup.string().required("Please fill the category"),
      sub_category: Yup.string(),
      club: Yup.string().required("Please fill the club"),
      club_img: Yup.mixed().required("Please fill the club image."),
      rikognition_status: Yup.string()
        .oneOf(
          GOAL_STATUS_OPTIONS.map((opt) => opt.value),
          "Please select a valid status",
        )
        .required("Please select a status"),
    }),

    onSubmit: async (values) => {
      values.goal_id = selectedGoal.id;
      setLoading(true);
      await handleGoalUpdate(values);
      setLoading(false);
    },
  });

  // console.log(
  //   goalCategory?.find((category) => category.id == formik.values.category)
  //     ?.subCategory,
  //   "alskfjalsd found sub catego",
  // );

  // "";


  useEffect(() => {
  }, []);

  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          if (loading) return;
          setOpen(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className="edit_user_modal"
          sx={{
            padding: "20px",
            overflow: "auto",
            width: "80%",
            maxWidth: "600px",
            height: "90%",
            bgcolor: "background.paper",
            borderRadius: "8px",
            boxShadow: 24,
          }}
        >
          <Card>
            <GoalVideo selectedGoal={selectedGoal} BlankImg={BlankImg} />

            <CardContent>
              <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom>
                      Edit Goal
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      name="title"
                      label="Title"
                      value={formik.values.title}
                      onChange={(e) =>
                        formik.setFieldValue("title", e.target.value)
                      }
                      placeholder="Describe the Goal"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      name="region"
                      label="Region"
                      value={formik.values.region}
                      onChange={(e) =>
                        formik.setFieldValue("region", e.target.value)
                      }
                      placeholder="Enter the region"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      name="postedBy"
                      label="Posted By"
                      value={formik.values.postedBy}
                      placeholder="Enter the name of the poster"
                      fullWidth
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      select
                      name="category"
                      label="Category"
                      value={formik.values.category}
                      onChange={(e) => {
                        formik.setFieldValue("category", e.target.value);
                        formik.setFieldValue("sub_category", "");
                      }}
                      placeholder="Select the category"
                      fullWidth
                    >
                      {categoryOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  {goalCategory?.find(
                    (category) => category.id == formik.values.category,
                  )?.subCategory?.length > 0 ? (
                    <Grid item xs={12}>
                      <TextField
                        select
                        name="sub_category"
                        label="Sub Category"
                        value={formik.values.sub_category}
                        onChange={(e) =>
                          formik.setFieldValue("sub_category", e.target.value)
                        }
                        placeholder="Select the Sub category"
                        fullWidth
                      >
                        {goalCategory?.loading
                          ? "...loading"
                          : goalSubCategoryOption?.map((option) => (
                              <MenuItem key={option.id} value={option.id}>
                                {option.name}
                              </MenuItem>
                            ))}
                      </TextField>
                    </Grid>
                  ) : null}
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formik.values.from_uk}
                          onChange={(e) =>
                            formik.setFieldValue("from_uk", e.target.checked)
                          }
                          name="from_uk"
                        />
                      }
                      label="From UK"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      name="club"
                      label="Club"
                      value={formik.values.club}
                      onChange={(e) =>
                        formik.setFieldValue("club", e.target.value)
                      }
                      placeholder="Enter the club name"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      name="goal_scorer"
                      label="Goal Scorer"
                      value={formik.values.goal_scorer}
                      onChange={(e) =>
                        formik.setFieldValue("goal_scorer", e.target.value)
                      }
                      placeholder="Enter the goal scorer"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      select
                      name="rikognition_status"
                      label="Status"
                      value={formik.values.rikognition_status}
                      onChange={(e) =>
                        formik.setFieldValue(
                          "rikognition_status",
                          e.target.value,
                        )
                      }
                      fullWidth
                    >
                      {GOAL_STATUS_OPTIONS.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12}>
                    <ImageUploadComponent formik={formik} />
                  </Grid>
                </Grid>
              </form>
            </CardContent>
            <CardActions sx={{ justifyContent: "flex-end" }}>
              <Button
                size="small"
                variant="contained"
                sx={{
                  bgcolor: "#EF364E",
                  color: "white",
                  "&:hover": { bgcolor: "#d32f2f" },
                }}
                onClick={() => formik.handleSubmit()}
                disabled={loading}
              >
                {loading ? (
                  <CircularProgress size="25px" sx={{ color: "white" }} />
                ) : (
                  "Save"
                )}
              </Button>
              <Button
                size="small"
                variant="outlined"
                sx={{
                  color: "#EF364E",
                  borderColor: "#EF364E",
                  "&:hover": { borderColor: "#d32f2f", color: "#d32f2f" },
                }}
                onClick={() => setOpen(false)}
                disabled={loading}
              >
                Exit
              </Button>
            </CardActions>
          </Card>
        </Box>
      </Modal>
    </>
  );
};

export default EditGoal;
